<div class="instant-logo" [ngClass]="size">
  <img src="{{ imgSrc }}" alt="{{ imgTitle }}" />
</div>
